import { FC } from "react";

import { PrescriberInfoProps } from "./types";



const ShowPrescriberInformation: FC<PrescriberInfoProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes, shipments_attributes, procedure_attributes } = getValues();

  return (
    <div className="card my-3">
      <div className="card-header">
        <h4 className="m-0">Prescription Information</h4>
      </div>
      <div className="card-body">
        <div className="row p-2">

          <div className="col-lg-6 col-md-6 col-12">
            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Product:</label>
              </div>
              <div className="col-7">
                {prescription_attributes && prescription_attributes.drug_name ? prescription_attributes.drug_name.replace(/^exparel/i, "EXPAREL") : "N/A"}
              </div>
            </div>

            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Quantity:</label>
              </div>
              <div className="col-7">
                <p>{prescription_attributes && prescription_attributes.qty ? prescription_attributes.qty : 0}</p>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Procedure (CPT/CDT):</label>
              </div>
              <div className="col-7">
                <p>{procedure_attributes && procedure_attributes.cpt_code ? procedure_attributes.cpt_code : 'N/A'}</p>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Diagnosis Code (ICD):</label>
              </div>
              <div className="col-7">
                <p>{prescription_attributes && prescription_attributes.diagnosis_code ? prescription_attributes.diagnosis_code.join(", ") : 'N/A'}</p>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Surgical Procedure:</label>
              </div>
              <div className="col-7">
                <p>{prescription_attributes && prescription_attributes.surgery ? prescription_attributes.surgery : 'N/A'}</p>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Notes:</label>
              </div>
              <div className="col-7">
                <p>{prescription_attributes && prescription_attributes.note ? prescription_attributes.note : 'N/A'}</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Indication For Use:</label>
              </div>
              <div className="col-7">
                <p>{prescription_attributes && prescription_attributes.direction ? prescription_attributes.direction : 'N/A'}</p>
              </div>
            </div>


            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Treatment Date:</label>
              </div>
              <div className="col-7">
                <p>{prescription_attributes && prescription_attributes.treatment_date ? prescription_attributes.treatment_date : 'N/A'}</p>
              </div>
            </div>
          
            <div className="row my-3">
              <div className="col-5">
                <label className="form-label">Site of Care:</label>
              </div>
              <div className="col-7">
                <p>
                  {shipments_attributes && shipments_attributes.length > 0 ? 
                    (shipments_attributes[0].practice_name ? 
                      shipments_attributes[0].practice_name
                      : 'N/A'
                    )
                    : 'N/A'
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowPrescriberInformation;
